const http = require('../lib/httpClient');
const { getCookie, getChannelId, getEcommId } = require('../lib/browserData');
const getZoneId = require('../lib/zoneData');
const getPoliticalId = require('../lib/politicalIdData');
const { COOKIES, DEFAULT_PRICE_GROUP, SELLER_EXPERIENCE } = require('../constants');
const getPoliticalIdWithLatLong = require('../lib/politicalIdDataWithLatLong');
const constants = require('../constants');

const SessionNotFoundError = {
  code: 'MERGE_CART_ERROR_SESSION_NOT_FOUND',
  message: 'Session not found',
};
const CartIdNotFoundError = {
  code: 'MERGE_CART_ERROR_CART_ID_NOT_FOUND',
  message: 'Cart ID to merge not found',
};
const MergeFailedError = {
  code: 'MERGE_CART_ERROR_MERGE_FAILED',
  message: 'Error while merging',
};

const endpointPattern = '/s/checkout/v1/carts/{cartId}/merge';

async function catalystMergeCart(tenantId, whitelabel, catalystBaseUrl = '') {
  const sessionId = getCookie(COOKIES.SESSION.VALUE);
  if (!sessionId) return { cartId: undefined, errors: [SessionNotFoundError] };
  const cartId = getCookie(COOKIES.CART_ID.VALUE);
  if (!cartId) return { cartId: undefined, errors: [CartIdNotFoundError] };
  const deliveryFlow = getCookie(COOKIES.DELIVERY_FLOW);

  const baseQuery = endpointPattern.replace('{cartId}', cartId);
  const endpoint = deliveryFlow ? `${baseQuery}?deliveryFlow=${deliveryFlow}` : baseQuery;

  const ecommName = getEcommId(tenantId, { whitelabel });
  const isTottus = ecommName.split('-')[0] === constants.ECOMM_NAME_TOTTUS;
  const {
    politicalId: tottusPoliticalId,
    lat,
    long,
  } = isTottus ? await getPoliticalIdWithLatLong(ecommName, catalystBaseUrl) : {};
  const reqBody = {
    metadata: {
      priceGroup: DEFAULT_PRICE_GROUP,
      ...(isTottus && lat && long && { latAndLong: { lat, long } }),
    },
  };
  if (getCookie(COOKIES.SELLER_EXPERIENCE) === SELLER_EXPERIENCE.MARKETPLACE) {
    reqBody.metadata.politicalAreaId = isTottus
      ? tottusPoliticalId
      : await getPoliticalId(tenantId, catalystBaseUrl);
  } else {
    reqBody.metadata.zoneId = await getZoneId(tenantId, catalystBaseUrl);
  }
  const result = await http.post(`${catalystBaseUrl}${endpoint}`, reqBody, {
    headers: {
      Authorization: sessionId,
      'x-channel-id': getChannelId(),
      'x-ecomm-name': ecommName,
    },
  });

  const { responseBody } = result || {};

  if (!responseBody) return { cartId: undefined, errors: [MergeFailedError] };
  const { errors, data: { cartId: mergedCart } = {} } = responseBody;
  if (errors) return { cartId: undefined, errors };
  if (!mergedCart) return { cartId: undefined, errors: [MergeFailedError] };
  return { cartId: mergedCart, errors: [] };
}

module.exports = catalystMergeCart;
